import { useCallback } from 'react'
import { useSearchParams } from 'next/navigation'

const CONTACTED_PARAM = 'contacted'
const REFERENCE_PARAM = 'enquiryRef'

/**
 * Whether the visitor already sent an enquiry for this package, and its lead reference, carried in
 * `?contacted=true&enquiryRef=<tripId>` so both survive a reload. The URL is the single source of
 * truth for every component that reacts to it.
 */
export const useHolidayContacted = () => {
    const searchParams = useSearchParams()
    const isContacted = searchParams.get(CONTACTED_PARAM) === 'true'
    const enquiryReference = isContacted ? searchParams.get(REFERENCE_PARAM) : null

    // history.replaceState syncs with useSearchParams in the App Router, without a server round trip.
    // The state must be null: passing Next's own state (it carries __NA) makes the router skip the sync.
    const markContacted = useCallback((reference: string) => {
        const url = new URL(window.location.href)
        url.searchParams.set(CONTACTED_PARAM, 'true')
        url.searchParams.set(REFERENCE_PARAM, reference)
        window.history.replaceState(null, '', url)
    }, [])

    return { isContacted, enquiryReference, markContacted }
}

export default useHolidayContacted
